import { BASE_URL, CANDIDATE, CANDIDATE_SEARCH_HISTORY } from "../../common/URLs";

const API_BASE_URL = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_SEARCH_HISTORY}`; 

export const fetchJobSearchHistory = async (token) => {
  const url = `${API_BASE_URL}`; 
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        // "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};


export const deleteJobSearchHistory = async (token, uuid) => {
  try {
    const response = await fetch(`${API_BASE_URL}/${uuid}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Error deleting : " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error deleting : " + error.message);
  }
};